import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop 組件
 * 在路由變更時自動滾動到頁面頂部
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // 當路徑變更時，滾動到頁面頂部
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // 這個組件不渲染任何 UI
};

export default ScrollToTop; 